"use strict";
/**
 * App notifications composable
 *
 * This provides a way for components to communicate to the app that they want certain types of
 * notifications to show, generally in areas of the page that a component itself does not control.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAppNotifications = exports.AppNotificationType = void 0;
const vue_1 = require("vue");
const pinia_1 = require("pinia");
const injection_symbols_1 = require("./injection-symbols");
const lifecycle_hooks_1 = require("./lifecycle-hooks");
const uuid_1 = require("uuid");
exports.AppNotificationType = {
    ALERT: 'alert'
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function createAppNotifications(options) {
    var _a, _b;
    const componentInstance = (0, vue_1.getCurrentInstance)();
    // Determine if Pinia is available.
    let activePinia;
    try {
        activePinia = (0, pinia_1.getActivePinia)();
    }
    catch (error) { /* Ignore */ }
    // List of all currently displaying notifications.
    const notifications = (_a = options === null || options === void 0 ? void 0 : options.notifications) !== null && _a !== void 0 ? _a : (0, vue_1.toRef)(activePinia
        // Using a Pinia store makes this state visible in Vue dev tools.
        ? (0, pinia_1.defineStore)('appNotifications', {
            state: () => {
                return {
                    notifications: []
                };
            }
        })()
        // If Pinia is not available, fall back to a regular ref.
        : { notifications: (0, vue_1.ref)([]) }, 'notifications');
    const localRegisteredCallbacks = (_b = (componentInstance && (0, vue_1.inject)(injection_symbols_1.appNotificationsRegisteredCallbacksKey))) !== null && _b !== void 0 ? _b : undefined;
    /** Internal method to transfer notifications to a new local instance */
    function _getRawNotifications() {
        return notifications;
    }
    /** Dismisses a notification that has the specified ID. */
    function dismiss(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const notificationIndex = notifications.value.findIndex((notification) => notification.id === id);
            if (notificationIndex > -1) {
                const notification = notifications.value[notificationIndex];
                notifications.value.splice(notificationIndex, 1);
                (0, lifecycle_hooks_1.runCallbacks)('notificationDismissed', notification, localRegisteredCallbacks);
            }
        });
    }
    /** Gets a computed list of notifications based on the specified filter criteria (updates automatically) */
    function getNotifications(filter) {
        return (0, vue_1.computed)(() => {
            return notifications.value.filter((notification) => {
                return ((!(filter === null || filter === void 0 ? void 0 : filter.type) || (filter === null || filter === void 0 ? void 0 : filter.type) === notification.type)
                    && (!(filter === null || filter === void 0 ? void 0 : filter.scope) || (filter === null || filter === void 0 ? void 0 : filter.scope) === notification.scope));
            });
        });
    }
    /** Present a notification. */
    function present(notification) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!notification.id) {
                notification.id = (0, uuid_1.v4)();
            }
            if (notification.type === exports.AppNotificationType.ALERT) {
                for (const action of (_a = notification.actions) !== null && _a !== void 0 ? _a : []) {
                    const userHandler = action.handler;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    action.handler = (data) => __awaiter(this, void 0, void 0, function* () {
                        // User must expliticly return false to prevent the default dismiss behavior.
                        const preventDismissFlag = yield (userHandler === null || userHandler === void 0 ? void 0 : userHandler(data));
                        if (preventDismissFlag !== false) {
                            dismiss(notification.id);
                        }
                    });
                }
            }
            notifications.value.push(notification);
            (0, lifecycle_hooks_1.runCallbacks)('notificationPresented', notification, localRegisteredCallbacks);
            return notification;
        });
    }
    const appNotifications = {
        _getRawNotifications,
        dismiss,
        getNotifications,
        present,
        install(app) {
            var _a;
            app.provide(injection_symbols_1.appNotificationsKey, appNotifications);
            app.provide(injection_symbols_1.appNotificationsRegisteredCallbacksKey, (_a = (componentInstance && (0, vue_1.inject)(injection_symbols_1.appNotificationsRegisteredCallbacksKey))) !== null && _a !== void 0 ? _a : (0, lifecycle_hooks_1.createRegisteredCallbacks)());
        }
    };
    return appNotifications;
}
exports.createAppNotifications = createAppNotifications;
//# sourceMappingURL=app-notifications.js.map